import { formNames } from '@wkda/carlead-creation-form';
import { isInvalidMobileError } from '@wkda/funnel-modules';
import { FORM_ERROR } from 'final-form';
import { getFieldSubmissionErrors } from '../getFieldSubmissionErrors';

// Error Handlers
export class ValidationDTOErrorHandler {
  canHandle(error) {
    return error.type === 'ERROR_RESPONSE_WITH_VALIDATION_DTO';
  }
  handleError(error, messages) {
    const errors = {};
    const {
      fieldErrors,
      globalErrors
    } = error.payload;
    const formFieldErrors = getFieldSubmissionErrors(fieldErrors, messages);
    if (isInvalidMobileError(error.payload)) {
      errors[formNames.mobile] = messages.invalidMobile;
    }
    if (globalErrors.length > 0) {
      errors[FORM_ERROR] = messages.globalUnknownError;
    }
    return {
      type: 'FIELD_ERRORS',
      payload: {
        ...errors,
        ...formFieldErrors
      }
    };
  }
}
export class DuplicatedCarleadErrorHandler {
  #ERROR_CODE = 'preventValidPriceDuplicates';
  canHandle(error) {
    return error.type === 'ERROR_RESPONSE_WITH_VALIDATION_DTO' && error.payload.globalErrors.includes('preventValidPriceDuplicates');
  }
  handleError(error) {
    return {
      type: 'DUPLICATED_CARLEAD',
      payload: {
        duplicatedCarleadHash: this.#getErrorPayload(error)
      }
    };
  }
  #getErrorPayload(error) {
    if (error.type !== 'ERROR_RESPONSE_WITH_VALIDATION_DTO') {
      return null;
    }
    const matchedError = error.payload.fieldErrors?.find(error => {
      return error.errorCode === this.#ERROR_CODE;
    });
    return matchedError?.message ?? null;
  }
}
export class DefaultErrorHandler {
  canHandle(_error) {
    return true;
  }
  handleError(_error) {
    return {
      type: 'FIELD_ERRORS',
      payload: {}
    };
  }
}